import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=070a2e17&scoped=true"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"
import style0 from "./empty.vue?vue&type=style&index=0&id=070a2e17&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070a2e17",
  null
  
)

export default component.exports